import { useState } from "react";
import { ArrowRight } from "lucide-react";
import EnquiryDialog from "@/components/EnquiryDialog";

export default function ProductCard({ product, index = 0 }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <article
        data-testid={`product-card-${product.id}`}
        className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm card-lift flex flex-col h-full group fade-up"
        style={{ animationDelay: `${index * 60}ms` }}
      >
        <div className="h-56 w-full overflow-hidden bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
          {product.image_position ? (
            <div
              role="img"
              aria-label={product.name}
              style={{
                backgroundImage: `url(${product.image_url})`,
                backgroundSize: "200% auto",
                backgroundPosition: product.image_position,
                backgroundRepeat: "no-repeat",
              }}
              className="w-full h-full group-hover:scale-105 transition-transform duration-500"
            />
          ) : (
            <img
              src={product.image_url}
              alt={product.name}
              loading="lazy"
              className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500"
            />
          )}
        </div>
        <div className="p-6 flex flex-col flex-grow gap-3">
          {product.highlights?.length > 0 && (
            <div className="flex flex-wrap gap-1.5">
              {product.highlights.slice(0, 3).map((h) => (
                <span
                  key={h}
                  className="text-[10px] uppercase tracking-wider font-semibold text-[#2A9D8F] bg-[#2A9D8F]/10 px-2 py-1 rounded-sm"
                >
                  {h}
                </span>
              ))}
            </div>
          )}
          <h3 className="font-display text-xl font-bold text-[#0B2545] leading-snug">
            {product.name}
          </h3>
          <p className="text-sm text-slate-600 leading-relaxed line-clamp-3">
            {product.description}
          </p>
          {product.pack_sizes?.length > 0 && (
            <div className="text-xs text-slate-500 mt-1">
              <span className="font-semibold text-[#1B4332]">Pack sizes: </span>
              {product.pack_sizes.join(" • ")}
            </div>
          )}
          <button
            onClick={() => setOpen(true)}
            data-testid={`enquire-btn-${product.id}`}
            className="mt-auto inline-flex items-center justify-between gap-2 bg-[#0B2545] hover:bg-[#13345F] text-white text-sm font-medium px-5 py-2.5 rounded-md transition-all group/btn"
          >
            <span>Enquire Now</span>
            <ArrowRight
              size={16}
              className="group-hover/btn:translate-x-1 transition-transform"
            />
          </button>
        </div>
      </article>
      <EnquiryDialog open={open} onOpenChange={setOpen} product={product} />
    </>
  );
}
